export enum YEAR_ENUM {
  YEAR_2014 = "2014",
  YEAR_2015 = "2015",
  YEAR_2016 = "2016",
  YEAR_2017 = "2017",
  YEAR_2018 = "2018",
  YEAR_2019 = "2019",
  YEAR_2020 = "2020",
  YEAR_2021 = "2021",
}
type ContentsItem = {
  img: string;
  text: string;
}
type ContentsType = {
  [value in YEAR_ENUM]: Array<ContentsItem>
}
export const CONTENTS: ContentsType = {
  [YEAR_ENUM.YEAR_2014]: [
    {
      img: "/milestone/img-milestone-01@3x.png",
      text: "milestone_item_2014_1",
    },
    {
      img: "/milestone/img-milestone-02@3x.png",
      text: "milestone_item_2014_2",
    },
    {
      img: "/milestone/img-milestone-03@3x.png",
      text: "milestone_item_2014_3",
    },
    {
      img: "/milestone/img-milestone-2014-4@3x.jpg",
      text: "milestone_item_2014_4",
    },
  ],
  [YEAR_ENUM.YEAR_2015]: [
    {
      img: "/milestone/img-milestone-04@3x.png",
      text: "milestone_item_2015_1",
    },
    {
      img: "/milestone/img-milestone-2015-2@3x.jpg",
      text: "milestone_item_2015_2",
    },
  ],
  [YEAR_ENUM.YEAR_2016]: [
    {
      img: "/milestone/img-milestone-05@3x.png",
      text: "milestone_item_2016_1",
    },
    {
      img: "/milestone/img-milestone-06@3x.png",
      text: "milestone_item_2016_2",
    },
  ],
  [YEAR_ENUM.YEAR_2017]: [
    {
      img: "/milestone/img-milestone-08@3x.png",
      text: "milestone_item_2017_2",
    },
  ],
  [YEAR_ENUM.YEAR_2018]: [
    {
      img: "/milestone/img-milestone-11@3x.png",
      text: "milestone_item_2018_3",
    },
    {
      img: "/milestone/img-milestone-12@3x.png",
      text: "milestone_item_2018_4",
    },
    {
      img: "/milestone/img-milestone-13@3x.png",
      text: "milestone_item_2018_5",
    },
  ],
  [YEAR_ENUM.YEAR_2019]: [
    {
      img: "/milestone/img-milestone-15@3x.png",
      text: "milestone_item_2019_2",
    },

    {
      img: "/milestone/imgHistory07@3x.png",
      text: "milestone_item_2019_4",
    },
  ],
  [YEAR_ENUM.YEAR_2020]: [
    {
      img: "/milestone/imgHistory06@3x.png",
      text: "milestone_item_2020_6",
    },
    {
      img: "/milestone/imgHistory05@3x.png",
      text: "milestone_item_2020_5",
    },
    {
      img: "/milestone/imgHistory04@3x.png",
      text: "milestone_item_2020_4",
    },
  ],
  [YEAR_ENUM.YEAR_2021]: [



    {
      img: "/milestone/imgHistory03@3x.png",
      text: "milestone_item_2021_3",
    },
    {
      img: "/milestone/imgHistory02@3x.png",
      text: "milestone_item_2021_2",
    },
    {
      img: "/milestone/imgHistory01@3x.png",
      text: "milestone_item_2021_1",
    },
  ],
};
